<template>
    <div class="chart">
        <div class="chart__categories">
            <div class="chart__category" v-for="item in chartData" :key="item.name">
                {{ item.name }}
            </div>
        </div>

        <div class="chart__activities">
            <div class="chart__bar" v-for="item in chartData" :key="item.name">
                <span v-if="item.today" :style="{width:  (item.today / maxValue) * 100 + '%'}" class="chart__bar-today"><span class="chart__bar-value">{{ item.today }}'</span></span>
                <span v-if="item.week" :style="{width: (item.week / maxValue) * 100 + '%'}" class="chart__bar-week"><span class="chart__bar-value">{{ item.week }}'</span></span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "ActivityChart",
    props: {
        subProfile: {
            type: Object
        }
    },
    data() {
        return {
            TIME_SPENT: '/api/krainaabc/subprofile/activity/time-spent',
            chartData: [],            
            maxValue: 0
        };
    }, 
    methods: {
        getTimeSpent() {
            let data = {};
            data['subProfile_id'] = this.subProfile._id;

            axios
                .post(this.TIME_SPENT, data)
                .then((response) => {
                    if (response.status === 200) {
                        if(response.data && response.data.data) {
                            this.chartData = response.data.data;
                            this.getMaxValue();
                        } 
                    }
                })            
        },    
        getMaxValue() {
            let max = 0;

            if(this.chartData) {
                this.chartData.forEach((item)=> {
                    if(item.today && item.today > max) {
                        max = item.today;
                    }
                    if(item.week && item.week > max) {
                        max = item.week;
                    }
                })
            }

            this.maxValue = max;
        }    
    },
    mounted() {
        this.getTimeSpent();
    },
    // updated() {
    //     this.getTimeSpent();   
    // }
};
</script>
